import { render, staticRenderFns } from "./PreparationBase.vue?vue&type=template&id=1addd0dc&scoped=true"
import script from "./PreparationBase.vue?vue&type=script&lang=js"
export * from "./PreparationBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1addd0dc",
  null
  
)

export default component.exports